import React from "react";

const InputGroup = ({ name, label, error,addOn , isPrepend,disabled, ...rest }) => {
  return (
    <React.Fragment>
        <div className="input-group">
            {isPrepend ?
            <div className="input-group-prepend">
                <span className="input-group-text" id={"addon" + name}>{addOn}</span>
            </div> : null}
            <input
                readOnly = {!disabled}
                {...rest}
                name={name}
                id={name}
                className="form-control"
                autoComplete="off"
            />
            {isPrepend ?
             null : <div className="input-group-append">
             <span className="input-group-text" id={"addon" + name}>{addOn}</span>
         </div>}
      </div>
      {error && <small className="text-danger help-block">{error}</small>}
    </React.Fragment>
  );
};

export default InputGroup;
